import { Leaf } from "lucide-react";
import { marqueeItems } from "../content/site";

export function Marquee() {
  const items = [...marqueeItems, ...marqueeItems, ...marqueeItems, ...marqueeItems];
  return (
    <div
      className="overflow-hidden border-y border-stone-900/10 bg-[#F3EFE6]"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="elwell-marquee-track flex w-max items-center whitespace-nowrap py-5">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif text-xl italic font-light text-stone-800 sm:text-2xl">{item}</span>
            <Leaf className="mx-10 h-3.5 w-3.5 text-emerald-900/60" strokeWidth={1.5} />
          </span>
        ))}
      </div>
    </div>
  );
}
